import { MBAlertConfirmOptions, MBAlertOptions } from './types';

export const MBAlert = {
  confirm({ message, onConfirm, onCancel }: MBAlertConfirmOptions): Promise<boolean> {
    return new Promise(resolve => {
      // eslint-disable-next-line no-alert
      if (window.confirm(message)) {
        onConfirm?.();
        resolve(true);
      }

      onCancel?.();
      resolve(false);
    });
  },

  alert({ message, onConfirm }: MBAlertOptions): Promise<boolean> {
    return new Promise(resolve => {
      // eslint-disable-next-line no-alert
      alert(message);
      onConfirm?.();
      resolve(true);
    });
  },
};
